import { render, staticRenderFns } from "./backup-settings-dialog.component.vue?vue&type=template&id=1f449652&scoped=true"
import script from "./backup-settings-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./backup-settings-dialog.component.ts?vue&type=script&lang=ts&external"
import style0 from "./backup-settings-dialog.component.vue?vue&type=style&index=0&id=1f449652&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f449652",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f449652')) {
      api.createRecord('1f449652', component.options)
    } else {
      api.reload('1f449652', component.options)
    }
    module.hot.accept("./backup-settings-dialog.component.vue?vue&type=template&id=1f449652&scoped=true", function () {
      api.rerender('1f449652', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/backup-settings/backup-settings-dialog.component.vue"
export default component.exports